import { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { NumberInput } from '@ui/components/NumberInput/NumberInput';
import { Tab, Tabs } from '@ui/components/Tabs';

import { NumberInTeamMode, TournamentMode } from '@features/shared/api/typings';
import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

const SWISS_OPTIONS: Tab<TournamentMode>[] = [
  { value: 'Private', label: 'Личный' },
  { value: 'Team', label: 'Командный' },
  {
    value: 'PrivateTeam',
    label: 'Лично-командный',
  },
  {
    value: 'TwoOnTwo',
    label: 'Два на два',
  },
];

const DEFAULT_OPTIONS: Tab<TournamentMode>[] = [
  { value: 'Private', label: 'Личный' },
  { value: 'Team', label: 'Командный' },
  {
    value: 'TwoOnTwo',
    label: 'Два на два',
  },
];

const SHIFT_OPTIONS: Tab<NumberInTeamMode>[] = [
  { value: 'Shift', label: 'Со сдвижкой' },
  { value: 'NoShift', label: 'Без сдвижки' },
];

export function ModeInput() {
  const { control, setValue } = useFormContext<TournamentEditFormValues>();
  const system = useWatch({ name: 'system', control });
  const mode = useWatch({ name: 'mode', control });
  const maxTeamSize = useWatch({ name: 'teamModeSettings.size', control });
  const playersToConsiderForScore = useWatch({
    name: 'privateTeamModeSettings.playersToConsiderForScore',
    control,
  });

  const tabs = system === 'Swiss' ? SWISS_OPTIONS : DEFAULT_OPTIONS;

  // Если выбрана отфильтрованная таба - переключаем
  useEffect(() => {
    if (!tabs.find((tab) => tab.value === mode)) {
      setValue('mode', tabs[0]!.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs]);

  useEffect(() => {
    if (playersToConsiderForScore && playersToConsiderForScore > maxTeamSize) {
      setValue('privateTeamModeSettings.playersToConsiderForScore', maxTeamSize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxTeamSize]);

  return (
    <>
      <FormRow>
        <FormLabel>Зачет</FormLabel>
        <FormInput>
          <Controller
            name="mode"
            control={control}
            render={({ field: { value, onChange, disabled } }) => (
              <Tabs tabs={tabs} value={value} onChange={onChange} disabled={disabled} />
            )}
          />
        </FormInput>
      </FormRow>

      {(mode === 'Team' || mode === 'PrivateTeam') && (
        <FormRow>
          <FormLabel>Игроков в команде</FormLabel>
          <FormInput>
            <Controller
              name="teamModeSettings.size"
              control={control}
              render={({ field: { value, onChange, disabled } }) => (
                <NumberInput
                  value={value}
                  onChange={onChange}
                  disabled={disabled}
                  min={2}
                  max={12}
                />
              )}
            />
          </FormInput>
        </FormRow>
      )}

      {mode === 'Team' && (
        <FormRow>
          <FormLabel>Сдвижка</FormLabel>
          <FormInput>
            <Controller
              name="teamModeSettings.numberInTeamMode"
              control={control}
              render={({ field: { value, onChange, disabled } }) => (
                <Tabs tabs={SHIFT_OPTIONS} value={value} onChange={onChange} disabled={disabled} />
              )}
            />
          </FormInput>
        </FormRow>
      )}

      {mode === 'PrivateTeam' && (
        <FormRow>
          <FormLabel>Игроков в зачете</FormLabel>
          <FormInput>
            <Controller
              name="privateTeamModeSettings.playersToConsiderForScore"
              control={control}
              render={({ field: { value, onChange, disabled } }) => (
                <NumberInput
                  value={value || 2}
                  onChange={onChange}
                  disabled={disabled}
                  min={2}
                  max={maxTeamSize}
                />
              )}
            />
          </FormInput>
        </FormRow>
      )}
    </>
  );
}
